import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, NgForm } from '@angular/forms';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-email-notifications',
    templateUrl: './email-notifications.component.html',
    styleUrls: ['./email-notifications.component.css'],
})

export class EmailNotificationsComponent implements OnInit {
    _groupToUpdate: any;

    constructor(
        public functionsService: FunctionsService,
        private apiService: ApiService,
        public spinner: NgxSpinnerService) { 
            this.functionsService.setTitle('setting.email_notifications');
        }

    ngOnInit(){
        this.getEmailLanguage();
    }

    getEmailLanguage(){
        this.spinner.show();
        this.apiService.getLanguage().subscribe(
            data => {
                if(document.getElementById(data["language"])){document.getElementById(data["language"])["checked"]=true;}
                else{
                    //Set default language
                    document.getElementById("EN")["checked"]=true;
                }
                this.spinner.hide();
            },
            error => {
                //Set default language
                document.getElementById("EN")["checked"]=true;
                this.spinner.hide();
            }
        );
    }

    setEmailLanguage(lang){
        this.spinner.show();
        this.apiService.setLanguage({"Language":lang}).subscribe(
            () => {
                localStorage.setItem('langSetting', lang);
                this.spinner.hide();
            },
            error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }
}